export class PopupEnum
{
  static help = "help";
  static user = "user";
}
